module.exports = __webpack_public_path__ + "img/webminar2.937cbf0b.png";